export const LOW_TIME_THRESHOLD_MS = 60_000;

export const getDeadlineMs = (cancelAt: string | undefined): number =>
  cancelAt ? new Date(cancelAt).getTime() : 0;

export const formatMinutesSeconds = (remainingMs: number): string => {
  const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
